module.exports = __webpack_public_path__ + "img/gongshui-5.a133c7d7.png";